import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=16157d9d&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Banner.vue?vue&type=style&index=1&id=16157d9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16157d9d",
  null
  
)

export default component.exports